(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.mmfaq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var answerId = this.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);

      // Close all others
      document.querySelectorAll('.mmfaq__q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var aId = b.getAttribute('aria-controls');
        var a = document.getElementById(aId);
        if (a) {
          a.classList.remove('is-open');
          a.hidden = true;
        }
      });

      if (!expanded) {
        this.setAttribute('aria-expanded', 'true');
        if (answer) {
          answer.hidden = false;
          answer.classList.add('is-open');
        }
      }
    });
  });

  /* /pages/faq#q_warranty opens that answer, so a link from the product
     page lands on the terms rather than a closed list of questions. Links
     between answers on this page (#q_kids) go through the same path. */
  function openFromHash() {
    var hash = window.location.hash.slice(1);
    var item = hash ? document.getElementById(hash) : null;
    if (!item || !item.classList.contains('mmfaq__item')) return;
    var q = item.querySelector('.mmfaq__q');
    if (q && q.getAttribute('aria-expanded') !== 'true') q.click();
    item.scrollIntoView({ block: 'start' });
  }
  window.addEventListener('hashchange', openFromHash);
  openFromHash();
})();

  } catch(e) { console.error(e); }
})();
})();
